class PageHeaderSection extends HTMLElement {
  constructor() {
    super();

    this.isSticky = this.dataset.sticky === "true";
    this.isStickyAlways = this.dataset.stickyAlways === "true";
    this.isTransparent = this.dataset.transparent === "true";
    this.isAlwaysMobileMenu = this.dataset.alwaysMobileMenu === "true";

    this.classBodyAlwaysMobileMenu = "mobile-nav";

    this.header = document.querySelector(".page-header");
    this.desktopMenuTrigger = document.querySelector(
      ".wt-header__sticky-menu-trigger",
    );
    this.desktopMenuBar = document.querySelector(".wt-drawer--nav");

    this.enabledClass = "sticky-enabled";
    this.showClass = "sticky-show";
    this.desktopHeaderWithMenuBarClass = "page-header--sticky-show-menubar-lg";
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.disableStickyHeader();
  }

  enbleStickyHeader() {
    if (!this.header) {
      console.error("Header element not found for enabling sticky header");
      return;
    }

    document.body.classList.add("page-header-sticky");

    let prevScrollpos = window.pageYOffset;

    const isDesktop = window.matchMedia("(min-width: 1200px)").matches;
    const isMenuBarOpen = () =>
      this.header.classList.contains(this.desktopHeaderWithMenuBarClass);
    const isHeaderWithDesktopNav =
      !document.body.classList.contains("mobile-nav");
    const allLLevelsLinks =
      this.desktopMenuBar?.querySelectorAll("a[data-menu-level]");
    const onlyLevel1Links = this.desktopMenuBar?.querySelectorAll(
      "a[data-menu-level='1']",
    );

    const calculateNavbarTopMargin = () => {
      const header = document.querySelector("#header");
      const navbar = document.querySelector("#wt-drawer-nav");
      let marginTop = 0;

      if (navbar.offsetHeight > header.offsetHeight) {
        marginTop = header.offsetHeight - navbar.offsetHeight;
      } else {
        marginTop = Math.abs(navbar.offsetHeight - header.offsetHeight);
      }

      navbar.style.setProperty("--top-margin", `${marginTop}px`);

      return marginTop;
    };

    calculateNavbarTopMargin();

    const stickyHeader = {
      show: () => {
        if (this.header) this.header.classList.add(this.showClass);
        stickyHeader.visible = true;
        stickyHeader.handleBehavior();
        calculateNavbarTopMargin();
      },
      hide: () => {
        if (this.header) this.header.classList.remove(this.showClass);
        stickyHeader.visible = false;
        stickyHeader.handleBehavior();
      },
      enable: () => {
        if (this.header) this.header.classList.add(this.enabledClass);
        stickyHeader.enabled = true;
        stickyHeader.handleBehavior();
      },
      disable: () => {
        if (this.header)
          this.header.classList.remove(this.enabledClass, this.showClass);
        stickyHeader.enabled = false;
        stickyHeader.handleBehavior();
      },
      enabled: false,
      visible: true,
      handleBehavior: () => {
        if (isHeaderWithDesktopNav && isDesktop && this.header) {
          stickyHeader.log();
          if (!isMenuBarOpen() && stickyHeader.enabled) {
            setTabindex(allLLevelsLinks, "-1");
          }
          if (isMenuBarOpen() && stickyHeader.enabled) {
            setTabindex(allLLevelsLinks, "0");
          }
          if (!stickyHeader.enabled) {
            setTabindex(onlyLevel1Links, "0");
            if (this.desktopMenuTrigger)
              setTabindex([this.desktopMenuTrigger], "-1");
          } else if (this.desktopMenuTrigger)
            setTabindex([this.desktopMenuTrigger], "0");
        }
      },
      log: () => {},
    };

    // Save the scroll handler for later removal
    this.scrollHandler = () => {
      const currentScrollPos = window.pageYOffset;
      if (!this.isStickyAlways) {
        if (prevScrollpos > currentScrollPos) {
          stickyHeader.show();
        } else {
          stickyHeader.hide();
        }
      } else {
        stickyHeader.show();
      }

      prevScrollpos = currentScrollPos;
    };

    window.addEventListener("scroll", this.scrollHandler);

    this.desktopMenuTrigger?.addEventListener("click", (e) => {
      e.preventDefault();
      this.desktopMenuBar?.classList.toggle("wt-drawer--nav-show");
      this.desktopMenuTrigger?.classList.toggle(
        "wt-header__sticky-menu-trigger--active",
      );
      this.header?.classList.toggle(this.desktopHeaderWithMenuBarClass);
      stickyHeader.handleBehavior();
    });

    const sentinel = document.querySelector(".sticky-header__threshold");
    const handleStickySentinel = (entries) => {
      entries.forEach(({ isIntersecting }) => {
        if (isIntersecting) {
          stickyHeader.disable();
        } else {
          stickyHeader.enable();
        }
      });
    };

    this.stickyHeaderObserver = new IntersectionObserver(handleStickySentinel, {
      root: null,
      rootMargin: `${this.isStickyAlways ? "-160" : "-100"}px 0px 0px 0px`,
      threshold: 0,
    });
    this.stickyHeaderObserver.observe(sentinel);
  }

  disableStickyHeader() {
    if (this.header) {
      // Remove classes added by sticky header
      this.header.classList.remove(
        this.enabledClass,
        this.showClass,
        this.desktopHeaderWithMenuBarClass,
      );
      document.body.classList.remove("page-header-sticky");
      this.desktopMenuBar?.classList.remove("wt-drawer--nav-show");
      this.desktopMenuTrigger?.classList.remove(
        "wt-header__sticky-menu-trigger--active",
      );
    }

    // Remove the scroll event listener
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
      this.scrollHandler = null;
    }

    // Disconnect the IntersectionObserver
    if (this.stickyHeaderObserver) {
      this.stickyHeaderObserver.disconnect();
      this.stickyHeaderObserver = null;
    }
  }

  init() {
    if (this.isSticky) {
      this.enbleStickyHeader();
    } else {
      this.disableStickyHeader();
    }
  }
}

customElements.define("page-header", PageHeaderSection);


// Function to apply color swatches on menu
(() => {
  // === Utilitários ===
  const normalize = (s = '') =>
    s.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
     .toLowerCase().replace(/\s+/g, ' ').trim();

  function injectStyles(id, css) {
    if (document.getElementById(id)) return;
    const style = document.createElement('style');
    style.id = id;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function withRetry(fn, maxAttempts = 10, intervalTime = 300) {
    let attempts = 0;
    const interval = setInterval(() => {
      fn();
      attempts++;
      if (attempts >= maxAttempts) clearInterval(interval);
    }, intervalTime);
  }

  // === Swatches do Menu ===
  function applyColorSwatches() {
    const colors = window.translatedColors;
    document.querySelectorAll('.wt-page-nav-mega__sublist__item--grandchild').forEach(item => {
      const text = item.textContent.toLowerCase();
      if (item.classList.contains('swatch-processed')) return;

      for (const [key, translatedValue] of Object.entries(colors)) {

        const normalizedColor = normalize(translatedValue);

        const colorRegex = new RegExp(
          `(^|[^a-z0-9])${normalizedColor.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}($|[^a-z0-9])`,
          'i'
        );

        if (colorRegex.test(normalize(text))) {
          const link = item.querySelector('a');

          if (link && !link.querySelector('.swatch-dot')) {
            const swatch = document.createElement('span');
            swatch.classList.add('swatch-dot', `swatch-${key}`);
            link.prepend(swatch);
            item.classList.add('swatch-processed');
          }

          break;
        }
      }
    });
  }

  // === Labels do Menu ===
  const MENU_ITEM_SELECTOR = '.wt-page-nav-mega__sublist__item--grandchild';
  const menuLabelBySlug = {
    'interior-walls': 'Dead Flat®, Modern Emulsion, Estate Emulsion',
    'interior-walls-and-ceilings': 'Dead Flat®, Modern Emulsion, Estate Emulsion',
    'interior-wood-and-metal': 'Dead Flat®, Modern Eggshell, Estate Eggshell, Full Gloss',
    'interior-wood-metal': 'Dead Flat®, Modern Eggshell, Estate Eggshell, Full Gloss',
    'interior-concrete-or-wooden-floors': 'Modern Eggshell',
    'exterior-wood-and-metal': 'Exterior Eggshell, Full Gloss',
    'exterior-wood-metal': 'Exterior Eggshell, Full Gloss',
    'exterior-walls': 'Exterior Masonry, Exterior Eggshell',
    'traditional-historic-properties': 'Limewash, Casein Distemper, Soft Distemper',
    'historic-properties': 'Limewash, Casein Distemper, Soft Distemper'
  };
  const menuLabelByText = {
    // English
    'interior walls & ceilings': 'Dead Flat®, Modern Emulsion, Estate Emulsion',
    'interior wood & metal': 'Dead Flat®, Modern Eggshell, Estate Eggshell, Full Gloss',
    'interior concrete or wooden floors': 'Modern Eggshell',
    'exterior wood & metal': 'Exterior Eggshell, Full Gloss',
    'exterior walls': 'Exterior Masonry, Exterior Eggshell',
    'traditional historic properties': 'Limewash, Casein Distemper, Soft Distemper',
    // Portuguese
    'paredes e tetos interiores': 'Dead Flat®, Modern Emulsion, Estate Emulsion',
    'madeira e metal interiores': 'Dead Flat®, Modern Eggshell, Estate Eggshell, Full Gloss',
    'pavimentos interiores em betao ou madeira': 'Modern Eggshell',
    'madeira e metal exteriores': 'Exterior Eggshell, Full Gloss',
    'paredes exteriores': 'Exterior Masonry, Exterior Eggshell',
    'edificios historicos e tradicionais': 'Limewash, Casein Distemper, Soft Distemper'
  };

  function injectMenuLabelStyles() {
    injectStyles('menu-labels-style', `
      ${MENU_ITEM_SELECTOR}.has-label > a { font-weight: 700 !important; }
      .menu-label { display: block; margin-top: 6px; font-size: 12px; line-height: 1.25rem; }
    `);
  }

  function findMenuLabel(link) {
    const href = (link.getAttribute('href') || '').toLowerCase();
    for (const slug in menuLabelBySlug) {
      if (href.includes(slug)) return menuLabelBySlug[slug];
    }
    const t = normalize(link.textContent || '');
    return menuLabelByText[t] || null;
  }

  function applyMenuLabels() {
    document.querySelectorAll(MENU_ITEM_SELECTOR).forEach(item => {
      const link = item.querySelector('a');
      if (!link) return;
      if (item.querySelector('.menu-label')) {
        item.classList.add('has-label');
        return;
      }
      const labelText = findMenuLabel(link);
      if (!labelText) return;
      const label = document.createElement('div');
      label.className = 'menu-label';
      label.setAttribute('data-i18n', 'menu.perfect_paint.label');
      label.textContent = labelText;
      link.insertAdjacentElement('afterend', label);
      item.classList.add('has-label');
    });
  }

  // === Label filter ===
  const FILTER_SECTION_SELECTOR = '.f-brands.filter.js-filter';
  const FILTER_TITLE_SELECTOR = '.filter__header';
  const filterLabelByText = menuLabelByText;

  function injectFilterLabelStyles() {
    injectStyles('filter-labels-style', `
      .filter-label { display: block !important; font-size: 12px; margin-bottom: 10px; line-height: 1.25rem; }
    `);
  }

  function applyFilterLabels() {
    document.querySelectorAll(FILTER_SECTION_SELECTOR).forEach(section => {
      const header = section.querySelector(FILTER_TITLE_SELECTOR);
      if (!header) return;
      const headerText = normalize(header.textContent || '');
      if (!headerText.includes('the best paint for') && !headerText.includes('a tinta perfeita para')) return;

      section.querySelectorAll('.list--checkbox .list__item').forEach(item => {
        const input = item.querySelector('.form-checkbox__input');
        const labelElement = item.querySelector('label.form-checkbox');
        if (!input || !labelElement) return;
        if (item.querySelector('.filter-label')) return;

        // Normaliza e remove números entre parênteses
        const rawText = input.dataset.label || labelElement.textContent;
        const cleanText = normalize(rawText.replace(/\(\d+\)/g, ''));
        const labelText = filterLabelByText[cleanText];
        if (!labelText) return;

        const labelDiv = document.createElement('div');
        labelDiv.className = 'filter-label';
        labelDiv.setAttribute('data-i18n', 'filter.perfect_paint.label');
        labelDiv.textContent = labelText;

        labelElement.insertAdjacentElement('afterend', labelDiv);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    injectMenuLabelStyles();
    injectFilterLabelStyles();

    applyColorSwatches();
    applyMenuLabels();
    applyFilterLabels();

    const drawer = document.getElementById('wt-drawer-nav');
    if (drawer) {
      new MutationObserver(() => {
        applyColorSwatches();
        applyMenuLabels();
      }).observe(drawer, { subtree: true, childList: true });
    }
    document.querySelectorAll('[aria-controls="wt-drawer-nav"]').forEach(btn => {
      btn.addEventListener('click', () => {
        withRetry(applyColorSwatches);
        withRetry(applyMenuLabels);
      });
    });

    document.querySelectorAll(FILTER_SECTION_SELECTOR).forEach(section => {
      new MutationObserver(() => applyFilterLabels())
        .observe(section, { subtree: true, childList: true });
    });
  });
})();

